export default {
    Bud: 'Bud',
    Rose: 'Rose',
    Thorn: 'Thorn',
};



// WEBPACK FOOTER //
// ./src/utils/ObservationTypes.ts